import { Form, Formik } from "formik";
import FormInput from "../../../../Universal/FormInput.component";
import DropDownInput from "../../../../Universal/DropDownInput.component";
import * as Yup from "yup";

const AddEditClassInfoForm = ({ _data, handelOutputData }) => {
  const handelSubmitForm = (formData) => handelOutputData(formData);
  const validationSchema = Yup.object().shape({
    sections: Yup.number()
      .required("Number of sections is required")
      .min(1, "Must be at least 1"),

    board: Yup.string().required("Board is required"),

    affiliationList: Yup.array()
      .min(1, "Select at least one affiliation")
      .of(Yup.string()),

    mode: Yup.string().required("Mode is required"),

    totalSeats: Yup.number()
      .required("Total seats are required")
      .min(1, "Must be at least 1"),
  });
  const isUpdate =
    _data?.sections ||
    _data?.board ||
    (Array.isArray(_data?.affiliationList) &&
      _data?.affiliationList.length > 0) ||
    _data?.totalSeats ||
    _data?.mode;
  return (
    <div
      className="p-2 back-white radius-10 flex-col align-left justify-start"
      style={{ width: "24rem" }}
    >
      <h3 className="t-17 poppins-medium color-textColor weight-500">
        Class: {_data?.class}
      </h3>
      <Formik
        initialValues={
          isUpdate
            ? { ..._data }
            : {
                class: _data?.class,
                sections: "",
                board: "",
                affiliationList: [],
                totalSeats: "",
                mode: "",
              }
        }
        onSubmit={(values) => {
          handelSubmitForm(values);
        }}
        validationSchema={validationSchema}
        enableReinitialize
      >
        {({ touched, errors, values, setFieldValue }) => {
          return (
            <Form className="flex-col align-left justify-start g-1 w-full">
              <FormInput
                name="sections"
                type="number"
                label="No. of sections(in any)"
                placeholder="Enter a number of sections"
                touched={touched}
                errors={errors}
                containerClass={"w-full"}
              />

              <DropDownInput
                name="board"
                label="Board"
                placeholder="Choose board name"
                value={values?.board}
                setFieldValue={(val) => setFieldValue("board", val)}
                touched={touched}
                errors={errors}
                suggestionList={["WBCHSC", "WBBME", "WBBSE"]}
              />
              <DropDownInput
                name="affiliationList"
                label="Affiliated by"
                placeholder="Choose affiliated by"
                value={values?.affiliationList}
                setFieldValue={(val) => setFieldValue("affiliationList", val)}
                touched={touched}
                errors={errors}
                suggestionList={["AICTE", "NAAC"]}
                multiple
              />
              <DropDownInput
                name="mode"
                label="Mode"
                placeholder="Choose mood of class"
                value={values?.mode}
                setFieldValue={(val) => setFieldValue("mode", val)}
                touched={touched}
                errors={errors}
                suggestionList={["Online", "Offline"]}
              />

              <FormInput
                name="totalSeats"
                type="number"
                label="No. of seats"
                placeholder="Enter a total number of seats"
                touched={touched}
                errors={errors}
                containerClass={"w-full"}
              />
              <button type="submit" className="actionBtn w-full">
                {isUpdate ? "Update" : "Add"}
              </button>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default AddEditClassInfoForm;
